<template>
    <form-range-slider class="uk-margin"
         :slug="data.slug"
         :label="data.label"
         :min="data.min"
         :max="data.max"
         :value="data.value"
    ></form-range-slider>
</template>

<script>
  import CatalogDynamicFilter from 'rubinred/catalog/js/mixins/CatalogDynamicFilter';

  export default {
    mixins: [CatalogDynamicFilter],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/extensions/rubinred/catalog/assets/js/components/CatalogRangeFilter.vue